import { firstDefined } from '@avantia/client-and-server-utilities';
import { HpError } from '@avantia/logging-and-errors';
import { HpClientQuestionLookupItem, HpInputControlProps } from '../../../types';
import { iterateLookupMap } from '../controlUtilities';
import { ButtonListControl, CategorisedLookupContent } from './buttonListControl';

export function ButtonCategoryListControl(props: HpInputControlProps): JSX.Element {
  const { lookup } = props.data;

  iterateLookupMap(lookup, props.ui, (option, key) => {
    const category = option && option.category;
    const optionText = firstDefined(option ? option.text : null, key);
    if (!category) {
      throw new HpError(`Category must be defined for ${key} ${optionText}.`);
    }
  });

  return <ButtonListControl createCategorisedLookup={createCategorisedLookup} {...props} />;
}

export function createCategorisedLookup(
  categoryLookupMap: string[],
  option: HpClientQuestionLookupItem | null,
  key: string
): CategorisedLookupContent {
  const category = firstDefined(option ? option.category : null, key);
  let element: JSX.Element | null = null;
  if (category && !categoryLookupMap.includes(category)) {
    element = createLookupCategoryTitle(category);
    categoryLookupMap.push(category);
  }

  return { element, categoryLookupMap };
}

function createLookupCategoryTitle(category: string) {
  return (
    <div className="hp-category" key={`${category}`}>
      <span className="av-label-text">{category}</span>
    </div>
  );
}
